module.exports = __webpack_public_path__ + "static/media/retail-landscape.c86cb493.jpg";